import React from 'react'

import { Button, Modal } from '@mui/material'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { Loading } from '../../Simple'

import './stylesED.css'

export default function ExcluirDados({ show, onClose }) {
  const { loadsUCtx, userUCtx, actionsUCtx } = React.useContext(UsuarioContext)

  const [confirmed, setConfirmed] = React.useState({ status: false, label: 'Enviar código para o meu e-mail' })

  return (
    <Modal open={show} className='contain-overlay-ed' onClose={onClose}>
      <div className='contain-content-ed'>
        <div className='modal-confirm-exclusion'>
          {loadsUCtx.deleteUser ? (
            <div className='contain-loading tw-p-7'>
              <Loading text={'Excluindo sua conta...'} />
            </div>
          ) : userUCtx.usuario.admin ? (
            <>
              <h1>Atenção</h1>
              <div className='contain-list-avisos-read'>
                <h3>- Você é gestor de uma quadra.</h3>
                <h3>- Para exclusão dos dados, entre em contato com a central de atendimento pelo App Gestor.</h3>
              </div>
              <Button
                fullWidth
                sx={{ marginTop: '15px', maxWidth: userUCtx.usuario.admin ? '200px' : '300px' }}
                variant='contained'
                color='error'
                onClick={() => {
                  onClose()
                }}
              >
                Voltar
              </Button>
            </>
          ) : (
            <>
              <h1>Deseja mesmo excluir seus dados?</h1>
              <h2 className='aviso-atencao'>ATENÇÃO</h2>
              <h2 className='aviso-sub-atencao'>Esta ação é irreversível</h2>
              <div className='contain-list-avisos'>
                <h3>- Todo dado relacionado a você será excluído da nossa plataforma.</h3>
                <h3>- Se você quiser voltar a utilizar o Agendei, precisará criar uma nova conta.</h3>
                <h3>- Ao confirmar, você voltará para a tela início imediatamente.</h3>
              </div>
              <Button
                fullWidth
                sx={{ marginTop: '15px', maxWidth: '300px', color: 'white' }}
                variant='contained'
                color={confirmed.status ? 'success' : 'info'}
                onClick={() => {
                  if (!confirmed.status) {
                    setConfirmed({ status: true, label: 'Confirmar exclusão' })
                  } else {
                    actionsUCtx.DeleteUser()
                  }
                }}
              >
                {confirmed.label}
              </Button>
              <Button
                fullWidth
                sx={{ marginTop: '15px', maxWidth: userUCtx.usuario.admin ? '200px' : '300px' }}
                variant='contained'
                color='error'
                onClick={() => {
                  onClose()
                }}
              >
                Voltar
              </Button>
            </>
          )}
        </div>
      </div>
    </Modal>
  )
}
